class VideoCarousel extends HTMLElement {
  connectedCallback() {
    this.videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector(".carousel-video");
          if (!video) return;
          if (entry.isIntersecting) {
            if (!video.src && video.dataset.src) video.src = video.dataset.src;
            video.play().catch(() => {
            });
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.01 }
    );
    this.querySelectorAll(".video-thumbnail").forEach(
      (thumb) => this.videoObserver.observe(thumb)
    );
  }
  disconnectedCallback() {
    this.videoObserver?.disconnect();
  }
}
customElements.define("video-carousel", VideoCarousel);
